/**
 * SIL-477 — Reports tab data layer. One real query
 * (`GET /api/client/environmental/reports`): the server-provided
 * verification status slot (R5 — never a hardcoded UI string) plus the
 * available-reports list (today: exactly one, the fleet carbon export that
 * also backs the Overview KPI reconciliation invariant — SIL-462 §4). No
 * sample fallback here — unlike the Overview/Circularity tabs' hybrid
 * widgets, there is nothing to fall back TO: an org with no computed data
 * gets a real, honest 'draft' status on the one real report, never a
 * fabricated second report.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { EnvironmentalReportsResponse } from '@siliconx/shared';
import { api, throwIfNotOk } from '../lib/api';
import { qk } from '../lib/queryKeys';

export function useEnvironmentalReportsQuery(): UseQueryResult<EnvironmentalReportsResponse> {
  return useQuery({
    queryKey: qk.environmental.reports(),
    queryFn: async () => {
      const res = await api.api.client.environmental.reports.$get();
      await throwIfNotOk(res);
      return res.json();
    },
  });
}
